export const FKC_ENTRIES_PER_CARD = 100;

export const FKC_MAX_CARD_COUNT = 3;

export const FKC_MAX_ENTRIES = FKC_ENTRIES_PER_CARD * FKC_MAX_CARD_COUNT;
